module.exports = __webpack_public_path__ + "media/images/gifts/light/sug_luz_7-f9ea98959958f45aad3e4e8cc871ec29.jpg";